/* Homnio homepage — quick add, variant chooser, cart-drawer handoff.
   No dependencies. Only runs on pages that contain .hh sections. */
(function () {
  'use strict';

  var root = document.querySelector('[data-hh-root]');
  if (!root) return;

  var routes = (window.routes || {});
  var addUrl = routes.cart_add_url || '/cart/add';
  var cartUrl = routes.cart_url || '/cart';

  /* ---------------------------------------------------------------- toast */
  var toastEl, toastTimer;
  function toast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>' +
        '<span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('hh-toast--error', !!isError);
    toastEl.querySelector('span').textContent = message;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ----------------------------------------------------- cart drawer sync */
  function syncCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-hc-cartcount]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function openCartDrawer() {
    if (window.theme && typeof window.theme.openCart === 'function') {
      window.theme.openCart();
      return true;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    return !!document.querySelector('[data-hc-cart]');
  }

  function addToCart(variantId, quantity) {
    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data && data.description ? data.description : 'cart-error');
        return data;
      });
    }).then(function (data) {
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { syncCartCount(cart); return data; })
        .catch(function () { return data; });
    });
  }

  function runAdd(button, variantId, label) {
    if (button.dataset.hhBusy === '1') return Promise.resolve(false);
    button.dataset.hhBusy = '1';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (button.tagName === 'BUTTON') button.disabled = true;
    var ok = false;

    return addToCart(variantId, 1)
      .then(function () {
        ok = true;
        toast((label || 'Item') + ' added to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (!openCartDrawer()) {
          setTimeout(function () { window.location.href = cartUrl; }, 600);
        }
      })
      .catch(function (err) {
        var msg = (err && err.message && err.message !== 'cart-error')
          ? err.message
          : 'Sorry — we could not add that just now. Please try again.';
        toast(msg, true);
      })
      .then(function () {
        button.dataset.hhBusy = '0';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (button.tagName === 'BUTTON') button.disabled = false;
        return ok;
      });
  }

  /* -------------------------------------------------------------- modal */
  var modal = null;
  var lastFocused = null;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'hh hh-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="hh-modal__scrim" data-hh-close></div>' +
      '<div class="hh-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hh-modal-title" tabindex="-1">' +
        '<div class="hh-modal__top">' +
          '<div>' +
            '<p class="hh-modal__title" id="hh-modal-title"></p>' +
            '<p class="hh-modal__hint">Choose an option to add to your cart.</p>' +
          '</div>' +
          '<button type="button" class="hh-modal__x" data-hh-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="hh-modal__opts" role="group" aria-label="Available options"></div>' +
        '<p class="hh-modal__err" hidden></p>' +
        '<a class="hh-modal__link" href="#">View full product details</a>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-hh-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('button:not([disabled]), a[href]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function openModal(trigger) {
    if (!modal) buildModal();
    var variants;
    try { variants = JSON.parse(trigger.getAttribute('data-hh-variants') || '[]'); }
    catch (e) { variants = []; }

    var title = trigger.getAttribute('data-hh-title') || 'Choose an option';
    var url = trigger.getAttribute('href') || cartUrl;

    if (!variants.length) { window.location.href = url; return; }

    lastFocused = trigger;
    modal.querySelector('.hh-modal__title').textContent = title;
    modal.querySelector('.hh-modal__link').setAttribute('href', url);
    var err = modal.querySelector('.hh-modal__err');
    err.hidden = true;
    err.textContent = '';

    var list = modal.querySelector('.hh-modal__opts');
    list.innerHTML = '';
    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hh-opt';
      var label = document.createElement('span');
      label.textContent = v.title + (v.available ? '' : ' — sold out');
      var price = document.createElement('span');
      price.className = 'hh-opt__price';
      price.textContent = v.price;
      if (v.compare) {
        var was = document.createElement('span');
        was.className = 'hh-opt__was';
        was.textContent = v.compare;
        price.appendChild(was);
      }
      btn.appendChild(label);
      btn.appendChild(price);
      if (!v.available) {
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () {
          runAdd(btn, v.id, title).then(function (ok) { if (ok) closeModal(); });
        });
      }
      list.appendChild(btn);
    });

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.hh-modal__panel').focus();
  }

  /* ------------------------------------------------------------ bindings */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-hh-quickadd]');
    if (quick) {
      e.preventDefault();
      runAdd(quick, quick.getAttribute('data-hh-variant'), quick.getAttribute('data-hh-title'));
      return;
    }
    var choose = e.target.closest('[data-hh-choose]');
    if (choose) {
      /* Progressive enhancement: without JS this stays a plain product link. */
      e.preventDefault();
      openModal(choose);
    }
  });
})();